var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"material-icons"},[_vm._v("expand_more")])
}
var staticRenderFns = []

export { render, staticRenderFns }